const domParser = new DOMParser();

if (!customElements.get('product-quick-add')) {
  class ProductQuickAdd extends HTMLElement {
    constructor() {
      super();

      this.bindOnOptionClick = this.onOptionClick.bind(this);
      this.bindOnSubmitHandler = this.onSubmitHandler.bind(this);
      this.bindOnNotifyClick = this.onNotifyClick.bind(this);
      this.bindOnSwatchClick = this.onSwatchClick.bind(this);
      this.bindExitClick = this.exitClick.bind(this);
      this.bindSetUpNotify = this.setUpNotify.bind(this);
    }

    connectedCallback() {
      this.setUp();
    }

    setUp() {
      this.options = Array.from(this.querySelectorAll('.product-quick-add__variant__option'));
      this.submit = this.querySelector('.product-quick-add__submit');
      this.notify = this.querySelector('.product-quick-add__notify');
      this.variantsJson = this.querySelector('.product-quick-add-json');
      this.variants = this.variantsJson ? JSON.parse(this.variantsJson.textContent) : null;
      this.notifyJsonWrapper = this.querySelector('.product-quick-notify-json');
      this.notifyJson = this.notifyJsonWrapper ? JSON.parse(this.notifyJsonWrapper.textContent) : null;
      this.form = this.querySelector('form');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.errorElement = this.querySelector('.product-quick-add__error');
      this.input = this.querySelector('input[name="id"]');
      this.price = this.querySelector('.product-quick-add__price');
      this.modal = document.querySelector('product-quick-add-modal');

      if (!this.form || !this.input) return;

      this.updateOptions();

      this.form.addEventListener('submit', this.bindOnSubmitHandler);

      this.options.forEach(option => {
        option.addEventListener('click', this.bindOnOptionClick)
      })

      if(this.hasAttribute('swatches')) {
        this.swatches = this.closest('.card')?.querySelectorAll('card-color-swatches .color-swatch, card-related-color-swatches .color-swatch');
        this.swatches?.forEach(swatch => {
          swatch.addEventListener('click', this.bindOnSwatchClick);
        })
      }

      if (!this.notifyJson || !this.notify) return;

      this.initRestockRocket();
    }

    initRestockRocket() {
      if (typeof window._RestockRocket !== 'undefined') {
        this.setUpNotify();
        return;
      }

      document.addEventListener('stoq:loaded', this.bindSetUpNotify, { once: true });

      let attempts = 0;
      const maxAttempts = 20;
      const pollInterval = 100;

      const checkRestockRocket = () => {
        attempts++;
        if (typeof window._RestockRocket !== 'undefined') {
          document.removeEventListener('stoq:loaded', this.bindSetUpNotify);
          this.setUpNotify();
          return;
        }
        if (attempts < maxAttempts) {
          setTimeout(checkRestockRocket, pollInterval);
        }
      };

      setTimeout(checkRestockRocket, pollInterval);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.bindOnSubmitHandler);
      this.options?.forEach(option => {
        option.removeEventListener('click', this.bindOnOptionClick)
      })
      this.swatches?.forEach(swatch => {
        swatch.removeEventListener('click', this.bindOnSwatchClick);
      })
      this.notify?.removeEventListener('click', this.bindOnNotifyClick);
    }

    open(opener) {
      this.setAttribute('open', '');
      requestAnimationFrame(() => {
        document.documentElement.addEventListener('click', this.bindExitClick)
        if (opener) {
          opener.classList.remove('loading');
          opener.removeAttribute('aria-disabled');
          opener.removeAttribute('disabled');
          opener.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      })
    }

    close() {
      this.removeAttribute('open');
      document.documentElement.removeEventListener('click', this.bindExitClick)
    }


    exitClick(event) {
      if (!event.target.closest('product-quick-add') && !event.target.closest('.color-swatch')) {
        this.close();
      }
    }

    onOptionClick(event) {
      const trigger = event.target.closest('.product-quick-add__variant__option');
      if (!trigger) {
        console.error('[Product Quick Add] No option trigger found.')
      }

      this.handleErrorMessage(null);

      this.submit.classList.add('loading');
      if (this.hasAttribute('direct-add')) {
        if (trigger.classList.contains('disabled')) {
          if (this.notifySetUp) {
            this.updateCurrentOption(trigger);
            this.updateVariant();
            requestAnimationFrame(() => {
              this.onNotifyClick();
              trigger.classList.remove('active');
            })
          }
        } else {
          this.classList.add('loading');
          this.updateCurrentOption(trigger);
          this.updateVariant();
          requestAnimationFrame(() => {
            this.submitForm();
          })
        }

      } else {
        if (trigger.classList.contains('disabled') && this.notifySetUp && this.hasAttribute('direct-notify')) {
          this.updateCurrentOption(trigger);
          this.updateOtherOptions(trigger)
          this.updateVariant();
          requestAnimationFrame(() => {
            this.onNotifyClick();
            trigger.classList.remove('active');
          })
        } else {
          this.changeOptions(trigger);
        }

      }
    }

    changeOptions(trigger) {
      this.updateCurrentOption(trigger);
      this.updateOtherOptions(trigger)
      this.updateVariant();
    }

    updateCurrentOption(trigger) {
      const optionPosition = trigger.dataset.optionPosition || '1';
      const optionSiblings = this.options.filter(op => op.dataset.optionPosition == optionPosition);
      optionSiblings.forEach(op => {
        const isActive = op === trigger;
        op.classList.toggle('active', isActive);
        if (op.hasAttribute('aria-pressed')) {
          op.setAttribute('aria-pressed', isActive);
        }
      })

      this.updateOptions();
    }

    updateOtherOptions(trigger) {
      const optionPosition = trigger.dataset.optionPosition || '1';
      const otherOptions = this.options.filter(op => op.dataset.optionPosition != optionPosition);
      otherOptions.forEach(op => {
        const opPosition = op.dataset.optionPosition || '1';
        const opValue= op.dataset.value || null;
        const optionVariant = this.variants.find(variant => {
          let matchOption1 = this.option1 == null ? variant.option1 == null : variant.option1 === this.option1;
          let matchOption2 = this.option2 == null ? variant.option2 == null : variant.option2 === this.option2;
          let matchOption3 = this.option3 == null ? variant.option3 == null : variant.option3 === this.option3;
          if (opPosition === '1') matchOption1 = opValue == null ? variant.option1 == null : variant.option1 === opValue;
          if (opPosition === '2') matchOption2 = opValue == null ? variant.option2 == null : variant.option2 === opValue;
          if (opPosition === '3') matchOption3 = opValue == null ? variant.option3 == null : variant.option3 === opValue;

          return matchOption1 && matchOption2 && matchOption3;
        }) || {available: false, id: null};

        if (this.hasAttribute('price-varies')) {
          op.dataset.price = optionVariant?.price;
          op.dataset.compareAtPrice = optionVariant?.compareAtPrice;
        }
        op.classList.toggle('disabled', !optionVariant.available);
      })
    }

    updateOptions() {
      this.option1 = this.options.find(op => op.dataset.optionPosition === '1' && op.classList.contains('active'))?.dataset.value;
      this.option2 = this.options.find(op => op.dataset.optionPosition === '2' && op.classList.contains('active'))?.dataset.value;
      this.option3 = this.options.find(op => op.dataset.optionPosition === '3' && op.classList.contains('active'))?.dataset.value;

      this.currentVariant = this.variants.find(variant => {
        const matchOption1 = this.option1 == null ? variant.option1 == null : variant.option1 === this.option1;
        const matchOption2 = this.option2 == null ? variant.option2 == null : variant.option2 === this.option2;
        const matchOption3 = this.option3 == null ? variant.option3 == null : variant.option3 === this.option3;
        return matchOption1 && matchOption2 && matchOption3;
      }) || null;
    }

    updateVariant() {
      this.submit.classList.remove('loading');

      if (this.currentVariant) {
        this.input.removeAttribute('aria-disabled');
        this.input.removeAttribute('disabled');
        this.input.value = this.currentVariant.id;
        this.submit.classList.remove('unavailable');
      } else {
        this.input.setAttribute('aria-disabled', true);
        this.input.setAttribute('disabled', true);
        this.submit.classList.add('unavailable');
      }

      if (this.price && this.currentVariant != null && this.currentVariant.price) {
        const url = getQuickAddUrl(this.dataset.url)
        const params = url.searchParams;
        params.set('variant', this.currentVariant.id);
        url.search = params.toString();
        fetch(url)
          .then((response) => response.text())
          .then((response) => {
            const html = domParser.parseFromString(response, 'text/html');
            const sourcePrice = html.querySelector('.product-quick-add__price');
            if (sourcePrice) {
              this.price.innerHTML = sourcePrice.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          })

      }

      this.updateSubmitButton(this.currentVariant?.available);
    }

    updateSubmitButton(available) {
      this.handleButtonDisable(!available);
      if (available) this.submit.querySelector('span').textContent = window.variantStrings.addToCart;
      else this.submit.querySelector('span').textContent = window.variantStrings.soldOut
    }

    submitForm(openerButton = null) {
      if (this.submit.getAttribute('aria-disabled') === 'true' || this.submit.hasAttribute('disabled')) return;
      this.handleButtonDisable(true)
      this.submit.classList.add('loading');
      this.submit.querySelector('.loading__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      let formData = new FormData(this.form);
       if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });

            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submit.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.handleButtonDisable(true);
            this.submit.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.modal) {
            this.modal.close();
          }
          this.submit.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error)  {
            this.handleButtonDisable(false);
          }
          this.submit.querySelector('.loading__spinner')?.classList.add('hidden');
          this.classList.remove('loading');
          if (openerButton) {
            openerButton.classList.remove('loading');
            openerButton.removeAttribute('aria-disabled');
            openerButton.removeAttribute('disabled');
            openerButton.querySelector('.loading__spinner')?.classList.add('hidden');
          }
          if (this.hasAttribute('direct-add')) {
            this.options.forEach((op) => {
              const opTagName = op.tagName.toLowerCase();
              if (opTagName == 'button') {
                op.classList.remove('active');
                op.blur();
              }
            })
          }
        });
    }

    onSubmitHandler(event) {
      event.preventDefault();
      if (!this.validateForm()) return;
      this.submitForm();
    }

    validateForm() {
      const variantId = this.input?.value;

      if (!variantId || variantId === '' || variantId === 'undefined') {
        this.handleErrorMessage(window.variantStrings?.unavailable || 'Please select a valid variant');
        return false;
      }

      if (!this.currentVariant) {
        this.handleErrorMessage(window.variantStrings?.unavailable || 'Selected variant is not available');
        return false;
      }

      if (!this.currentVariant.available) {
        this.handleErrorMessage(window.variantStrings?.soldOut || 'This variant is sold out');
        return false;
      }

      return true;
    }

    handleErrorMessage(errorMessage = false) {
      if (!this.errorElement) return;

      this.errorElement.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorElement.textContent = errorMessage;
        this.scrollTo({ top: this.scrollHeight, behavior: 'smooth' });
      } else {
        this.errorElement.textContent = '';
      }
    }

    handleButtonDisable(disable) {
      if (disable) {
        this.submit.setAttribute('aria-disabled', true);
        this.submit.setAttribute('disabled', true);
      } else {
        this.submit.removeAttribute('aria-disabled');
        this.submit.removeAttribute('disabled');
      }
    }

    setUpNotify() {
      if (this.notify && this.notifyJson) {
        this.notifySetUp = true;
        this.notify.removeAttribute('disabled')
        this.notify.removeAttribute('aria-disabled');
        this.notify.addEventListener('click', this.bindOnNotifyClick)
      }
    }
    onNotifyClick() {
      if (!this.currentVariant?.id) return;
      window._RestockRocket.openModal(this.notifyJson, this.currentVariant.id);
    }

    onSwatchClick(event) {
      event.preventDefault();
      const target = event.target.closest('.color-swatch');
      const url = getQuickAddUrl(target.href);

      this.classList.add('loading');

      this.swatches.forEach(swatch => {
        swatch.classList.toggle('is-active', swatch === target);
      })
      const button = document.querySelector(`.product-quick-add-opener[data-target="${this.id}"] button`);
      if (button) {
        button.dataset.productUrl = target.href;
      }
      this.renderQuickAdd(url, this.closest('.product-quick-add-wrapper'))
    }

    renderQuickAdd(url, target, id = this.id, formId = this.dataset.formId) {
      if (!url || !target || !id || !formId) return;
      const isOpen = this.hasAttribute('open')
      fetch(url)
        .then((response) => response.text())
        .then((response) => {
          const html = domParser.parseFromString(response, 'text/html')
          const source = html.querySelector('.product-quick-add-wrapper');
          if (source) {
            const sourceId = source.querySelector('product-quick-add').id;
            const sourceFormId = source.querySelector('product-quick-add').dataset.formId;
            if (isOpen) {
              source.querySelector('product-quick-add').setAttribute('open', '');
            }
            target.innerHTML = source.innerHTML.replaceAll(sourceId, id).replaceAll(sourceFormId, formId);
            if (isOpen) {
              target.querySelector('product-quick-add').open();
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.classList.remove('loading');
        })
    }
  }

  customElements.define('product-quick-add', ProductQuickAdd);
}

if (!customElements.get('product-quick-add-opener')) {
  class ProductQuickAddOpener extends HTMLElement {
    constructor() {
      super();

      this.bindOnClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('button');

      this.button.addEventListener('click', this.bindOnClick);

    }

    resetButton() {
      this.button.classList.remove('loading');
      this.button.removeAttribute('aria-disabled');
      this.button.removeAttribute('disabled');
      this.button.querySelector('.loading__spinner')?.classList.add('hidden');
    }

    loadQuickAdd(productUrl) {
      const wrapper = this.parentElement?.querySelector('.product-quick-add-wrapper--lazy')
        || this.closest('.card')?.querySelector('.product-quick-add-wrapper--lazy');
      if (!wrapper) return Promise.resolve();
      if (wrapper.querySelector('product-quick-add')) return Promise.resolve();
      if (wrapper.dataset.loading) return Promise.resolve();

      wrapper.dataset.loading = 'true';

      const targetId = this.dataset.target;
      const formId = 'ProductQuickAddForm-' + (targetId || '').replace('ProductQuickAdd-', '');

      return fetch(productUrl)
        .then((response) => response.text())
        .then((response) => {
          const html = domParser.parseFromString(response, 'text/html');
          const source = html.querySelector('.product-quick-add-wrapper');
          if (!source) return;
          const sourceQuickAdd = source.querySelector('product-quick-add');
          if (!sourceQuickAdd) return;
          const sourceId = sourceQuickAdd.id;
          const sourceFormId = sourceQuickAdd.dataset.formId;
          wrapper.innerHTML = source.innerHTML
            .replaceAll(sourceId, targetId)
            .replaceAll(sourceFormId, formId);
          wrapper.classList.remove('product-quick-add-wrapper--lazy');
        })
        .finally(() => {
          delete wrapper.dataset.loading;
        });
    }

    onClick(event) {
      this.button.classList.add('loading');
      this.button.setAttribute('aria-disabled', true);
      this.button.setAttribute('disabled', true);
      this.button.querySelector('.loading__spinner')?.classList.remove('hidden');

      this.modal = document.querySelector('product-quick-add-modal');

      let productUrl = getQuickAddUrl(this.button.dataset.productUrl);
      if (this.hasAttribute('product')) {
        productUrl = window.location;
      }

      if (this.hasAttribute('data-direct-opener')) {
        this.loadQuickAdd(productUrl)
          .then(() => {
            const quickAdd = document.getElementById(this.dataset.target);
            if (quickAdd) quickAdd.submitForm(this.button);
            else this.resetButton();
          })
          .catch((e) => {
            console.error(e);
            this.resetButton();
          });
        return;
      }

      if ((this.hasAttribute('mobile-modal') && window.innerWidth < 750) || (this.hasAttribute('desktop-modal') && window.innerWidth >= 750)) {
        if (this.modal) this.modal.renderProduct(productUrl, this);
        return;
      }

      this.loadQuickAdd(productUrl)
        .then(() => {
          this.quickAdd = document.querySelector(`#${this.dataset.target}`);
          if (this.quickAdd) this.quickAdd.open(this.button);
          else this.resetButton();
        })
        .catch((e) => {
          console.error(e);
          this.resetButton();
        });
    }
  }

  customElements.define('product-quick-add-opener', ProductQuickAddOpener);
}

if (!customElements.get('product-quick-add-modal')) {
  class ProductQuickAddModal extends HTMLElement {
    constructor() {
      super();
      this.bindExitClick = this.exitClick.bind(this);
      this.bindOnWindowResize = debounce(this.onWindowResize.bind(this), 200);
      this.bindOnKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.content = this.querySelector('.product-quick-add-modal__content');
      window.addEventListener('resize', this.bindOnWindowResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.bindOnWindowResize);
    }

    open() {
      this.previousActiveElement = document.activeElement;
      this.setAttribute('open', '');
      requestAnimationFrame(() => {
        this.addEventListener('click', this.bindExitClick);
        document.addEventListener('keydown', this.bindOnKeyDown);
        this.trapFocus();
      })
    }

    close() {
      this.removeAttribute('open');
      this.removeEventListener('click', this.bindExitClick);
      document.removeEventListener('keydown', this.bindOnKeyDown);
      this.previousActiveElement?.focus();
    }

    trapFocus() {
      const focusableElements = this.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      }
    }

    onKeyDown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }

      if (event.key === 'Tab') {
        const focusableElements = Array.from(this.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ));
        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }

    exitClick(event) {
      if (!event.target.closest('product-quick-add')) {
        this.close();
      }
    }

    renderProduct(url, opener) {
      if (!url || !this.content) return;

      this.opener = opener;

      fetch(url)
        .then((response) => response.text())
        .then((response) => {
          const html = domParser.parseFromString(response, 'text/html')
          const source = html.querySelector('.product-quick-add-wrapper');
          if (source) {
            this.content.innerHTML = source.innerHTML;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.open();
          if (this.opener) {
            this.opener.classList.remove('loading');
            this.opener.removeAttribute('aria-disabled');
            this.opener.removeAttribute('disabled');
            this.opener.querySelector('.loading__spinner')?.classList.add('hidden');
          }
          const openerButton = this.opener.querySelector('button')
          if (openerButton) {
            openerButton.classList.remove('loading');
            openerButton.removeAttribute('aria-disabled');
            openerButton.removeAttribute('disabled');
            openerButton.querySelector('.loading__spinner')?.classList.add('hidden');
          }
        })
    }

    onWindowResize() {
      if (this.hasAttribute('open')) {
        if (!this.opener.hasAttribute('mobile-modal') && window.innerWidth < 750) {
          this.close();
        }
        if (!this.opener.hasAttribute('desktop-modal') && window.innerWidth >= 750) {
          this.close();
        }
      }
    }
  }

  customElements.define('product-quick-add-modal', ProductQuickAddModal);
}


const getQuickAddUrl = (url) => {
  if (!url.includes('/products/')) return;

  const parsedUrl = url.startsWith('/') ? window.location.origin + url : url

  const newUrl = new URL(parsedUrl);
  const params = newUrl.searchParams;
  params.set('view', `quick-add`);
  newUrl.search = params.toString();

  return newUrl;
}